<template>
  <el-dialog title="详情" :visible.sync="visible" width="800px" :before-close="handleClose" :close-on-click-modal="false"
    append-to-body>
    <div class="detail-content">
      <el-table :data="tableData" border stripe size="small" class="detail-table" :show-header="false">
        <el-table-column prop="label" width="120" align="center">
          <template slot-scope="scope">
            <span class="label-text">{{ scope.row.label }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="value" min-width="200">
          <template slot-scope="scope">
            <span class="value-text">{{ scope.row.value }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>

  </el-dialog>
</template>

<script>
export default {
  name: 'LogDetailDialog',
  data() {
    return {
      visible: false,
      table: {
        channelName: '',
        et: '',
        manufacturer: '',
        unitType: '',
        chipName: '',
        sysv: '',
        productName: '',
        appv: '',
        sdkv: '',
        uid: '',
        hid: '',
        cid: '',
        mac: '',
        pn: '',
        context: '',
        createTime: '',
        euqid: ''
      },
      tableData: []
    }
  },
  methods: {
    // 打开对话框
    open(data) {
      const payload = data || {}
      // 将后端返回字段映射到表单
      Object.keys(this.table).forEach(key => {
        this.table[key] = payload[key] == null ? '' : payload[key]
      })

      // 构建表格数据
      this.buildTableData()
      this.visible = true
    },

    // 构建表格数据
    buildTableData() {
      const fieldMapping = [
        { key: 'channelName', label: '应用名称' },
        { key: 'et', label: '问题类型' },
        { key: 'manufacturer', label: '厂商' },
        { key: 'unitType', label: '设备型号' },
        { key: 'chipName', label: '芯片名称' },
        { key: 'sysv', label: '系统版本' },
        { key: 'productName', label: '产品类型' },
        { key: 'appv', label: '客户端版本' },
        { key: 'sdkv', label: 'SDK版本号' },
        { key: 'uid', label: 'UID' },
        { key: 'hid', label: 'HID' },
        { key: 'cid', label: 'CID' },
        { key: 'mac', label: 'MAC' },
        { key: 'pn', label: '手机号' },
        { key: 'context', label: '问题描述' },
        { key: 'createTime', label: '上报时间' },
        { key: 'euqid', label: '双端关联ID' }
      ]

      this.tableData = fieldMapping.map(item => ({
        label: item.label,
        value: this.table[item.key] || ''
      }))
    },

    // 关闭对话框
    handleClose() {
      this.visible = false
      // 重置为初始值
      Object.keys(this.table).forEach(key => {
        this.table[key] = ''
      })
      this.tableData = []
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.detail-content {
  max-height: 500px;
  overflow-y: auto;
}

.detail-table {
  .el-table__body-wrapper {
    max-height: 400px;
    overflow-y: auto;
  }

  .label-text {
    font-weight: bold;
    font-size: 14px;
  }

  .value-text {
    font-size: 14px;
  }
}
</style>
